export default "__VITE_ASSET__BkqJtAyr__"